import React, { FC } from 'react';
import { useI18n, useLicenses } from '~Hooks';
import HandyPageWrapper from '~Scenes/Handy/Components/HandyPageWrapper';
import HandySettingsBlock, {
  SettingBlockItemType,
} from '~Scenes/Handy/Components/HandySettingsBlock';
import { IconType } from '~Scenes/Handy/Components/RoundedIcon';
import { usePage } from '~Scenes/Handy/Context/PageProvider';

const HandySettings: FC = () => {
  const page = usePage();

  const { i18n } = useI18n();
  const licenses = useLicenses();

  const hasOrderLicense = licenses.hasHandheldOrder || licenses.hasHandheldPro;

  const navigationBlocks: SettingBlockItemType[] = [
    {
      id: 'printer-settings',
      title: i18n('Handy.Settings.PrintersTitle'),
      bigTitle: true,
      prefixIcon: {
        type: IconType.PRINTER,
        bgColor: 'rgb(7 122 180)',
      },
      action: {
        icon: {
          type: IconType.FORWARD_ARROW,
        },
        onClick: () => {
          page.navigateTo('printerSettings');
        },
      },
    },
    {
      id: 'kitchen-tickets-settings',
      title: i18n('Handy.Settings.KitchenTickets'),
      bigTitle: true,
      prefixIcon: {
        type: IconType.KITCHEN_TICKET,
        bgColor: 'rgb(116 112 177)',
      },
      action: {
        icon: {
          type: IconType.FORWARD_ARROW,
        },
        onClick: () => {
          page.navigateTo('kitchenTicketsSettings');
        },
      },
    },
    {
      id: 'receipt-settings',
      title: i18n('Handy.Settings.ReceiptsTitle'),
      bigTitle: true,
      prefixIcon: {
        type: IconType.RECEIPT,
        bgColor: 'rgb(240 136 75)',
      },
      action: {
        icon: {
          type: IconType.FORWARD_ARROW,
        },
        onClick: () => {
          page.navigateTo('receiptSettings');
        },
      },
    },
    {
      id: 'payment-settings',
      title: i18n('Handy.Settings.PaymentsTitle'),
      bigTitle: true,
      prefixIcon: {
        type: IconType.PAYMENTS,
        bgColor: 'rgb(88 161 88)',
      },
      action: {
        icon: {
          type: IconType.FORWARD_ARROW,
        },
        onClick: () => {
          page.navigateTo('paymentSettings');
        },
      },
    },
    {
      id: 'staff-settings',
      title: i18n('Handy.Settings.StaffTitle'),
      bigTitle: true,
      prefixIcon: {
        type: IconType.STAFF,
        bgColor: 'rgb(0, 0, 0)',
      },
      action: {
        icon: {
          type: IconType.FORWARD_ARROW,
        },
        onClick: () => {
          page.navigateTo('staffSettings');
        },
      },
    },
    {
      id: 'table-settings',
      title: i18n('Settings.Tables'),
      bigTitle: true,
      prefixIcon: {
        type: IconType.RESTAURANT,
        bgColor: 'rgb(67 140 198)',
      },
      action: {
        icon: {
          type: IconType.FORWARD_ARROW,
        },
        onClick: () => {
          page.navigateTo('tableSettings');
        },
      },
    },
    {
      id: 'device-settings',
      title: i18n('Handy.Settings.DeviceTitle'),
      bigTitle: true,
      prefixIcon: {
        type: IconType.CHECK,
        bgColor: 'rgb(198 166 67)',
      },
      action: {
        icon: {
          type: IconType.FORWARD_ARROW,
        },
        onClick: () => {
          page.navigateTo('deviceSettings');
        },
      },
    },
    {
      id: 'general-settings',
      title: i18n('Handy.Settings.GeneralTitle'),
      bigTitle: true,
      prefixIcon: {
        type: IconType.COG_WHEEL,
        bgColor: 'rgb(131 131 131)',
      },
      action: {
        icon: {
          type: IconType.FORWARD_ARROW,
        },
        onClick: () => {
          page.navigateTo('general');
        },
      },
    },
  ];

  if (hasOrderLicense) {
    const posLayoutSettings: SettingBlockItemType = {
      id: 'pos-layout-settings',
      title: i18n('Handy.Settings.PosLayoutTitle'),
      bigTitle: true,
      prefixIcon: {
        type: IconType.LAYOUT_CHANGE,
        bgColor: 'rgb(190 103 155)',
      },
      action: {
        icon: {
          type: IconType.FORWARD_ARROW,
        },
        onClick: () => {
          page.navigateTo('posLayoutSettings');
        },
      },
    };

    navigationBlocks.splice(2, 0, posLayoutSettings);
  }

  return (
    <>
      <HandyPageWrapper pageTitle={i18n('Handy.Settings')}>
        <HandySettingsBlock items={navigationBlocks} />
      </HandyPageWrapper>
    </>
  );
};

export default HandySettings;
